export const TableHelpers = {
  data() {
    return {
      tableColumns: [
        {
          title: "Código",
          type: "text",
          key: "code",
        },
        {
          title: "Tipo",
          type: "custom-html",
          key: "type_document",
          modifier: (value) => {
            return value.name;
          }
        },
        {
          title: "Área",
          type: "custom-html",
          key: "accreditation_area",
          modifier: (value) => {
            return value? value.name : '';
          }
        },
        {
          title: this.$t('Fecha de inicio de vigencia '),
          type: 'custom-html',
          key: 'start_date_validity',
          modifier: (value) => {
              return moment(String(value)).format('YYYY-MM-DD');
          }
      },

        {
          title: "Estado",
          type: "custom-html",
          key: "is_active",
          isVisible: true,
          modifier: (item) => {
            let className = "success";
            let status = "Activo";
            if (item == 0) {
              className = "danger";
              status = "Inactivo";
            }
            return `<span class="badge badge-sm badge-pill badge-${className}">${status}</span>`;
          },
        },
      ],
      actionObj: {
        title: "Acciones",
        type: "action",
      },
    };
  },
};
